import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import PsContext from "../../../context";
import { APP_TYPE, COLLEGE } from "../../../utils";
import { ServiceUrl } from "../../../utils/serviceUrl";
import newIcon from "../../../assets/images/new_gif.gif";

const TopScrollAnnouncement = (props) => {
  const context = useContext(PsContext);
  const [dataList, setDataList] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    let url = "";
    if (APP_TYPE === "SAAS") url = "?sadb=" + COLLEGE;
    axios.get(ServiceUrl.ADMISSION.ANNOUNCEMENTS + url).then((res) => {
      if (res["data"].status === "1") {
        setDataList(res["data"].data);
      }
      setLoader(false);
    });
  };

  if (dataList.length === 0) return null;

  return (
    <div className="top-scroll-announcement-bar">
      <div
        className="announcement-label bg-theme text-white cursor-pointer"
        onClick={() => context.setShowAdmissionAlert(true)}
      >
        <i className="fa-solid fa-bullhorn me-2"></i>
        Announcements
      </div>
      <div className="announcement-marquee-wrapper">
        <div className="announcement-marquee-content">
          {dataList.map((item, index) => (
            <div key={index} className="announcement-item">
              <img src={newIcon} alt="New" className="new-icon" />
              <div
                className="announcement-text text-black"
                dangerouslySetInnerHTML={{
                  __html: item.title,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopScrollAnnouncement;
